import { render } from "./ProductsSubCategory.vue?vue&type=template&id=579a1d5e&scoped=true"
import script from "./ProductsSubCategory.vue?vue&type=script&lang=js"
export * from "./ProductsSubCategory.vue?vue&type=script&lang=js"

import "./ProductsSubCategory.vue?vue&type=style&index=0&id=579a1d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579a1d5e"]])

export default __exports__